module.exports = __webpack_public_path__ + "img/testimonials-icon-blue.6d05be38.svg";